export type NotificatioForm = Record<enNotificationNames, NotificationTypes>;

export enum enNotificationNames {
  newContent = 'newContent',
  newCourseTrack = 'newCourseTrack',
  commentResponse = 'comment',
  sendEmailToStudents = 'sendEmailToStudents'
}

export interface NotificationTypes {
  email: boolean;
  push: boolean;
}
export interface IUnsubscribedProducer {
  id: number;
  name: string;
}

export interface INotificationItem {
  key: enNotificationNames;
  title: string;
  description: string;
  disablePush?: boolean;
}

export interface IUserNotification {
  course_id: number;
  course_title: string;
  cover_url: string;
  created_at: string;
  description: string;
  id: string;
  link: string;
  message: string;
  new_cover_url: string;
  payload: {
    type: string;
    value: string;
  };
  read: boolean;
  subtitle: string;
  target_url: string;
  title: string;
}
